import { BUSCAR_EMISSOES_CTE_OS } from '../../actions/types'

const initialState = undefined;

const initial = {
  emissaoCteOS: [],
  total: 0
};

export default function reducerBuscarEmissoesCteOs (state = initial, action = initialState) {
  switch (action.type) {
    case BUSCAR_EMISSOES_CTE_OS: {
      const emissoes = action.payload.data;

      if (emissoes) {
        return {
          ...state,
          emissaoCteOS: emissoes.emissaoCteOS,
          total: emissoes.total
        }
      }

      return initial
    }

    // case LIMPAR_EMISSOES_CTE_OS:
    //   return [];

    default: {
      return state
    }
  }
}
